import React from 'react';
import classNames from 'classnames';
import { isEqual } from 'lodash';
import { Wix } from '@wix/js-sdk-provider';
import ReactResizeDetector from 'react-resize-detector';
import { ArrowIcon } from './ArrowIcon';
import { Badge } from '../Badge';
import './badge-list.scss';
import { getTranslationFunction } from '../../services/i18n';
const marginBottom = 4;
const PRIMARY_COLOR = 'color-5';
export class BadgeList extends React.Component {
    constructor(props) {
        super(props);
        this.siteColors = this.props.siteColors;
        this.setWrapperRef = (element) => {
            this.wrapperRef = element;
        };
        this.setRemainderRef = (element) => {
            this.remainderRef = element;
        };
        this.getBadgeHeight = () => {
            const ref = this.wrapperRef;
            if (ref) {
                const firstChild = ref.childNodes[0];
                if (!firstChild) {
                    return 0;
                }
                const badgeHeight = firstChild.scrollHeight;
                const margin = parseInt(window.getComputedStyle(firstChild).getPropertyValue('margin-bottom'), 10);
                return badgeHeight + margin;
            }
            return 0;
        };
        this.getColor = (colorName) => {
            var _a;
            return this.siteColors &&
                this.siteColors.find((color) => color.reference === colorName)
                ? (_a = this.siteColors.find((color) => color.reference === colorName)) === null || _a === void 0 ? void 0 : _a.value
                : 'black';
        };
        this.getRemainderColor = () => {
            return this.props.remainderColor || this.getColor(PRIMARY_COLOR);
        };
        this.filterBadges = () => {
            const { filteredBadges } = this.state;
            const { badges, maxRows, maxBadges } = this.props;
            if (maxBadges && maxBadges > 0) {
                this.setState({
                    wrapperHeight: undefined,
                    remainder: badges.length - maxBadges,
                    filteredBadges: filteredBadges.length !== maxBadges
                        ? badges.slice(0, maxBadges)
                        : filteredBadges,
                });
                return;
            }
            const ref = this.wrapperRef;
            if (ref) {
                if (this.remainderRef) {
                    ref.removeChild(this.remainderRef);
                }
                const tops = [];
                // eslint-disable-next-line @typescript-eslint/prefer-for-of
                for (let i = 0; i < ref.childNodes.length; i++) {
                    const child = ref.childNodes[i];
                    tops.push(child.offsetTop);
                }
                const uniqueTops = Array.from(new Set(tops));
                const maxRowsReached = uniqueTops[maxRows - 1] === undefined;
                const finalTop = maxRowsReached
                    ? uniqueTops[uniqueTops.length - 1]
                    : uniqueTops[maxRows - 1];
                const wrapperHeight = finalTop + this.getBadgeHeight() - marginBottom;
                let remainder = tops.filter((top) => top > finalTop).length;
                const lastChild = ref.childNodes[tops.length - remainder];
                ref.insertBefore(this.remainderRef, lastChild);
                const checkRemainder = (i) => {
                    var _a;
                    if (((_a = this.remainderRef) === null || _a === void 0 ? void 0 : _a.offsetTop) >= wrapperHeight &&
                        i < tops.length) {
                        ref.removeChild(this.remainderRef);
                        const prevChild = ref.childNodes[tops.length - remainder - i];
                        remainder++;
                        this.setState({ remainder }, () => {
                            ref.insertBefore(this.remainderRef, prevChild);
                            checkRemainder(i + 1);
                        });
                    }
                };
                this.setState({ wrapperHeight, remainder, filteredBadges: badges }, () => checkRemainder(1));
            }
        };
        this.renderRemainder = () => {
            const { borderRadius, layout, size, font, useTextRemainder, onClickMore, background, } = this.props;
            const cursorClass = onClickMore ? 'pointer' : '';
            const borderClass = background ? '' : 'no-border';
            const backgroundClass = background ? '' : 'no-background';
            const remainderClass = classNames('remainder', layout, size, backgroundClass, cursorClass, borderClass);
            const color = this.getRemainderColor();
            if (this.state.remainder > 0 && !useTextRemainder) {
                return (React.createElement("div", { onClick: onClickMore, className: remainderClass, style: { borderRadius, color, borderColor: color, fontFamily: font } },
                    "+",
                    this.state.remainder));
            }
            return React.createElement("div", null);
        };
        const { maxBadges, badges } = props;
        this.state = {
            wrapperHeight: 0,
            remainder: 4,
            filteredBadges: maxBadges && maxBadges > 0 ? badges.slice(0, maxBadges) : props.badges,
        };
    }
    async componentDidMount() {
        this.filterBadges();
        if (!this.props.siteColors) {
            this.siteColors = Wix.Styles.getSiteColors();
            Wix.addEventListener(Wix.Events.STYLE_PARAMS_CHANGE, () => {
                this.siteColors = Wix.Styles.getSiteColors();
                this.filterBadges();
            });
        }
        if (!this.t) {
            this.t = await getTranslationFunction(this.props.i18n, this.props.language);
        }
    }
    componentDidUpdate(prev) {
        if (isEqual(this.props, prev)) {
            return;
        }
        this.filterBadges();
    }
    render() {
        const { filteredBadges } = this.state;
        const { layout, size, borderRadius, font, background, align, useTextRemainder, onClickMore, hideDefaultIcon, } = this.props;
        const backgroundClass = background ? '' : 'no-background';
        const wrapperClass = classNames('badge-list-wrapper', layout, size, align, backgroundClass);
        const color = this.getRemainderColor();
        return (React.createElement(ReactResizeDetector, { handleWidth: true, handleHeight: true, onResize: this.filterBadges }, () => {
            var _a;
            return (React.createElement("div", { className: "members-badge-list-lib-style-wrapper" },
                React.createElement("div", { className: wrapperClass, ref: this.setWrapperRef, style: { height: this.state.wrapperHeight } },
                    filteredBadges.map((badge) => (React.createElement(Badge, { key: badge.id, badge: badge, layout: layout, size: size, borderRadius: borderRadius, font: font, background: background, onLoadIcon: this.filterBadges, onClick: this.props.onBadgeClick, hideDefaultIcon: hideDefaultIcon, httpClient: this.props.httpClient }))),
                    React.createElement("span", { ref: this.setRemainderRef }, this.renderRemainder())),
                useTextRemainder && this.state.remainder > 0 && !!onClickMore && (React.createElement("div", { className: "textRemainderWrapper" },
                    React.createElement("span", { onClick: onClickMore, style: { fontFamily: font, color } },
                        React.createElement("span", null, (_a = this.t) === null || _a === void 0 ? void 0 : _a.call(this, 'view_all_badges')),
                        React.createElement(ArrowIcon, null))))));
        }));
    }
}
//# sourceMappingURL=BadgeList.js.map